import React from "react";
import { Row, Col } from "reactstrap";
import styled from "styled-components";
import "react-nice-dates/build/style.css";
import { ChevronRight } from "@styled-icons/bootstrap/ChevronRight";
import { CFormLabel, CFormInput } from "@coreui/react";
import { DateRangePicker, START_DATE, END_DATE } from "react-nice-dates";
import { sv } from "date-fns/locale";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CreateAPLPeriodGeneral({
  aplName,
  aplStartDate,
  aplEndDate,
  aplHoursPerWeek,
  aplDaysPerWeek,
  handleSetDaysPerWeek,
  handleSetHoursPerWeek,
  handleSetName,
  handleSetStartDate,
  handleSetEndDate,
  setAplValidationErrors,
  aplValidationErrors,
}) {
  const validateName = (data) => {
    if (data.target.value === "") {
      setAplValidationErrors([...aplValidationErrors, "aplName"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplName")
      );
      handleSetName(data.target.value);
    }
  };

  const validateDate = (date, startOrEnd) => {
    if (date === "") {
      setAplValidationErrors([...aplValidationErrors, "aplDate"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplDate")
      );
      if (startOrEnd === "start") {
        handleSetStartDate(date);
      } else {
        handleSetEndDate(date);
      }
    }
  };
  /***********Commented until furher notice, when implemented uncomment*************/
  /* const validateAplHoursPerWeek = (data) => {
    if (data === "") {
      setAplValidationErrors([...aplValidationErrors, "aplHoursPerWeek"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplHoursPerWeek")
      );
      handleSetHoursPerWeek(data);
    }
  };

  const validateAplDaysPerWeek = (data) => {
    if (data === "") {
      setAplValidationErrors([...aplValidationErrors, "aplDaysPerWeek"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplDaysPerWeek")
      );
      handleSetDaysPerWeek(data);
    }
  }; */

  return (
    <Col>
      <Row style={{ alignItems: "baseline" }}>
        <Col lg={3}></Col>
        <Col lg={9}>
          <span className="text-warning">
            <FontAwesomeIcon
              icon="exclamation-triangle"
              style={{ marginRight: "0.1rem" }}
            />
          </span>
          <span className="font-italic">
            <FormattedMessage id="ConsiderUsingANameThatCanBeFoundLater" />.
          </span>
        </Col>
      </Row>
      <Row style={{ alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="Name" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="text"
            id="aplName"
            name="aplName"
            defaultValue={aplName !== "" ? aplName : ""}
            placeholder="Namn på period"
            autoComplete="false"
            onChange={(data) => validateName(data)}
          />
          {aplValidationErrors.some((item) => item === "aplName") ? (
            <p className="text-danger">
              <FormattedMessage id="Views.Admin.Module.NameIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row className="mb-3"></Row>
      <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <label>
            <FormattedMessage id="Period" />:
          </label>
        </Col>
        <Col lg={9}>
          <DateRangePickerWrapper>
            <DateRangePicker
              startDate={aplStartDate}
              endDate={aplEndDate}
              onStartDateChange={(value) => validateDate(value, "start")}
              onEndDateChange={(value) => validateDate(value, "end")}
              minimumDate={new Date()}
              minimumLength={1}
              format="yyyy-MM-dd"
              locale={sv}
            >
              {({ startDateInputProps, endDateInputProps, focus }) => (
                <span className="date-range">
                  <Col lg={4} style={{ display: "inline-block", padding: "0" }}>
                    <CFormInput
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="från"
                      style={{ textAlign: "center" }}
                    />
                  </Col>
                  <Chevron />
                  <Col lg={4} style={{ display: "inline-block", padding: "0" }}>
                    <CFormInput
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="till"
                      style={{ textAlign: "center" }}
                    />
                  </Col>
                </span>
              )}
            </DateRangePicker>
          </DateRangePickerWrapper>

          {aplValidationErrors.some((item) => item === "aplDate") ? (
            <p className="text-danger">
              <FormattedMessage id="StartAndEndDateIsRequiredForPeriod" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      {/***********Commented until furher notice, when implemented uncomment*************/}
      {/* <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="HoursPerWeek" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="number"
            id="aplHoursPerWeek"
            name="aplHoursPerWeek"
            defaultValue={aplHoursPerWeek !== null ? aplHoursPerWeek : null}
            onBlur={(data) => validateAplHoursPerWeek(data.target.value)}
            placeholder="Antal timmar per vecka..."
            autoComplete="false"
          />
          {aplValidationErrors.some((item) => item === "aplHoursPerWeek") ? (
            <p className="text-danger">
              <FormattedMessage id="HoursPerWeekIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="DaysPerWeek" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="number"
            id="aplDaysPerWeek"
            name="aplDaysPerWeek"
            defaultValue={aplDaysPerWeek !== null ? aplDaysPerWeek : null}
            onBlur={(data) => validateAplDaysPerWeek(data.target.value)}
            placeholder="Antal dagar per vecka..."
            autoComplete="false"
          />
          {aplValidationErrors.some((item) => item === "aplDaysPerWeek") ? (
            <p className="text-danger">
              <FormattedMessage id="DaysPerWeekIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row> */}
    </Col>
  );
}
const Chevron = styled(ChevronRight)`
  height: 1rem;
  width: 1rem;
  margin: auto 0.5rem;
`;

const DateRangePickerWrapper = styled.div`
  .nice-dates-popover {
    width: 80%;
  }
`;
